import { render, staticRenderFns } from "./SuperAdminLiveCourses.vue?vue&type=template&id=b057b90a&scoped=true"
import script from "./SuperAdminLiveCourses.vue?vue&type=script&lang=js"
export * from "./SuperAdminLiveCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b057b90a",
  null
  
)

export default component.exports